export enum Role {
  Admin = 'Admin',
  FullContractor = 'FullContractor',
  LimitedAdmin = 'LimitedAdmin',
}
